"use client";
import CustomInput from '@/app/_components/CustomInput';
import Heading from '@/app/_components/Heading';
import { Button } from '@/components/ui/button';
import React, { startTransition, useActionState, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { resetPasswordSchema } from '@/schema/auth';
import type { z } from 'zod';
import ErrorBanner from '@/app/_components/ErrorBanner';
import { showToast } from '@/app/_components/toast';
import { resetPasswordAction, type ResetPasswordState } from '@/actions/auth';

const ResetPassword = ({onNext} : {onNext : () => void}) => {
  const [state, formAction, isPending] = useActionState<ResetPasswordState, FormData>(resetPasswordAction, { success: false });
  const [isErrorDismissed, setIsErrorDismissed] = useState(false);
  type FormValues = z.infer<typeof resetPasswordSchema>;
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<FormValues>({
    resolver: zodResolver(resetPasswordSchema),
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });
  const formRef = useRef<HTMLFormElement | null>(null);

  // Show toast and advance to next step on successful response
  useEffect(() => {
    if (state.success) {
      
      if (onNext) {
        onNext();
      }
    } else if (state.message && !state.success) {
      showToast.error(state.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.success, state.message]);
  return (
     <div className="flex max-w-120 flex-col">
      
      <Heading size="3xl" className="text-text-900 mb-3.5">
        Reset Password
      </Heading>
      <p className='text-body-medium/md text-text-700 mb-10.5'>Please enter your new password below.</p>

      {state.message && !state.success && !isErrorDismissed && (
        <ErrorBanner message={state.message} onDismiss={() => setIsErrorDismissed(true)} />
      )}

      <form
        ref={formRef}
        className="mb-4 flex flex-col gap-4"
        noValidate
        onSubmit={handleSubmit(() => {
          setIsErrorDismissed(false);
          const fd = new FormData(formRef.current as HTMLFormElement);
          startTransition(() => {
            formAction(fd);
          });
        })}
      >
        <CustomInput
            label="New Password"
            type="password"
            placeholder="· · · · · · · · · ·"
            error={errors.password?.message ?? state.errors?.password?.[0]}
            {...register("password")}
            name="password"
        />
         <CustomInput
            label="Confirm Password"
            type="password"
            placeholder="· · · · · · · · · ·"
            error={errors.confirmPassword?.message ?? state.errors?.confirmPassword?.[0]}
            {...register("confirmPassword")}
            name="confirmPassword"
            showPasswordToggle
        />

        <Button className='mt-6.5' type="submit" disabled={isPending || isSubmitting}>
          {"Reset password"}
        </Button>
      </form>
      
    </div>
  )
}

export default ResetPassword